import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import WordCloud from '../components/WordCloud';
import namesData from '../data/namesData.ts';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "word-cloud"
    }}>{`Word Cloud`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/WordCloud"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    {
      /* https://worldpopulationreview.com/state-rankings/alcohol-consumption-by-state */
    }
    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#7375A5\">\n  <WordCloud\n    className=\"word-cloud\"\n    width={360}\n    height={270}\n    data={namesData}\n    encoding={{\n      color: {\n        field: \'count\',\n        scale: {\n          range: [\'#7375A5\', \'#fff\'],\n          zero: true,\n        },\n        type: \'quantitative\',\n      },\n      emoji: {\n        field: \'count\',\n        scale: {\n          type: \'threshold\',\n          domain: [1000000, 2000000],\n          range: [\'\', \'☃️\', \'️❄️\'],\n        },\n        type: \'quantitative\',\n      },\n      fontFamily: {\n        value: \'Raleway, Helvetica, sans-serif\',\n      },\n      fontSize: {\n        field: \'count\',\n        scale: {\n          range: [0, 40],\n        },\n        type: \'quantitative\',\n      },\n      fontWeight: {\n        value: \'normal\',\n      },\n      text: { field: \'name\' },\n    }}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      WordCloud,
      namesData,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#7375A5" mdxType="Frame">
    <WordCloud className="word-cloud" width={360} height={270} data={namesData} encoding={{
          color: {
            field: "count",
            scale: {
              range: ["#7375A5", "#fff"],
              zero: true
            },
            type: "quantitative"
          },
          emoji: {
            field: "count",
            scale: {
              type: "threshold",
              domain: [1000000, 2000000],
              range: ["", "☃️", "️❄️"]
            },
            type: "quantitative"
          },
          fontFamily: {
            value: "Raleway, Helvetica, sans-serif"
          },
          fontSize: {
            field: "count",
            scale: {
              range: [0, 40]
            },
            type: "quantitative"
          },
          fontWeight: {
            value: "normal"
          },
          text: {
            field: "name"
          }
        }} mdxType="WordCloud" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      